// ScrollReveal Configuration - Webflow-style animations
// Based on tenniswise.fr animation patterns

// Global defaults for smoother animations
ScrollReveal({
  duration: 800,
  easing: 'cubic-bezier(0.5, 0, 0, 1)',
  viewFactor: 0.15,
  viewOffset: { top: 50, bottom: 50 }
});

// Fade up animation (most common - like Webflow)
ScrollReveal().reveal('.appear-up', {
  origin: 'bottom',
  distance: '60px',
  duration: 900,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Fade in (opacity only, no movement)
ScrollReveal().reveal('.appear-fade', {
  distance: '0px',
  opacity: 0,
  duration: 800,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Slide from left
ScrollReveal().reveal('.appear-left', {
  origin: 'left',
  distance: '60px',
  duration: 900,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Slide from right
ScrollReveal().reveal('.appear-right', {
  origin: 'right',
  distance: '60px',
  duration: 900,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Slide from top
ScrollReveal().reveal('.appear-top', {
  origin: 'top',
  distance: '40px',
  duration: 800,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Scale up effect
ScrollReveal().reveal('.appear-scale', {
  scale: 0.9,
  opacity: 0,
  duration: 800,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Staggered animations for grid items (like cards)
// Use on parent with children having .appear-stagger class
ScrollReveal().reveal('.appear-stagger', {
  origin: 'bottom',
  distance: '40px',
  duration: 700,
  delay: 100,
  interval: 150, // Stagger delay between each element
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Staggered fade (no movement, just opacity)
ScrollReveal().reveal('.appear-stagger-fade', {
  distance: '0px',
  opacity: 0,
  duration: 600,
  delay: 100,
  interval: 100,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Special hero animation (larger movement)
ScrollReveal().reveal('.appear-hero', {
  origin: 'bottom',
  distance: '80px',
  duration: 1200,
  delay: 300,
  easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
});

// Zoom in animation
ScrollReveal().reveal('.appear-zoom', {
  scale: 0.8,
  opacity: 0,
  duration: 900,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});

// Rotate in animation
ScrollReveal().reveal('.appear-rotate', {
  rotate: { x: 0, y: 0, z: -10 },
  distance: '30px',
  origin: 'bottom',
  duration: 800,
  delay: 200,
  easing: 'cubic-bezier(0.5, 0, 0, 1)'
});
